import React from "react";
import product1 from "../../img/productWanita/Poliester Kyuck Goo Jaket Putih (L)/product3.jpg";
import { Rating } from "react-simple-star-rating";

function Ulasan1() {
  return (
    <div>
      <div>
        <h1 className="font-bold text-2xl mb-4">Ulasan Toko</h1>
      </div>
      <div className="flex mb-8">
        <div className="w-28 h-28 mr-6">
          <img src={product1} alt="" className="object-cover h-full w-full" />
        </div>
        <div className="grid grow">
          <div>
            <h1 className="font-bold text-xl">
              Poliester Kyuck Goo Jaket Putih
            </h1>
          </div>
          <div>
            <Rating size={23} initialValue={1} readonly={true} />
          </div>
          <div>
            <h1 className="text-xs text-gray-400 mb-2 mt-1  ">
              Putri, 22-07-2022 14.23
            </h1>
          </div>
          <div>
            <h1 className="font-bold">Produk sesuai</h1>
          </div>
          <div>
            <p className="text-sm">
              Pakaian nyaman dipakai, kualitas masih bagus dan oke banget
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ulasan1;
